import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScalarResponseModel } from "../../models/scalar/scalar.model";

@Injectable({
    providedIn: 'root'
})
export class SMTPMessagingService {

    private SMTP_MESSAGING_URL = 'api/messaging/smtp/{destination}/{subject}/{body}'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.SMTP_MESSAGING_URL;
    }

    sendSMTPMessage$(destination: string, subject: string, body: string): Observable<ScalarResponseModel> {
        console.log("sendSMTPMessage$");
        let x = this.url.replace('{destination}', destination);
        let y = x.replace('{subject}', subject);
        let z = y.replace('{body}', body);
        return this._httpClient.get<ScalarResponseModel>(`${z}`);
    }

}
